import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../constants/accountSettingsPages';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 * Customer-oriented navigation only.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ProfileDashboardPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  const { className, rootClassName, currentPage } = props;
  const classes = classNames(rootClassName || css.root, className);

  const isProvider = props?.currentUser?.attributes?.profile?.publicData?.userType === 'provider';
  const isAdmin = props?.currentUser?.attributes?.profile?.publicData?.userType === 'admin';

  const tabs = [
    {
      text: <FormattedMessage id="UserNav.profileDashboard" />,
      selected: currentPage === 'ProfileDashboardPage',
      disabled: false,
      linkProps: {
        name: 'ProfileDashboardPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.orders" />,
      selected: currentPage === 'OrdersPage',
      disabled: false,
      linkProps: {
        name: 'OrdersPage',
      },
    },
    {
      text: <FormattedMessage id={isProvider ? 'UserNav.sellerRequests' : 'UserNav.myRequests'} />,
      selected:
        currentPage === 'MyRequestsPage' ||
        currentPage === 'NewSupportRequestPage' ||
        currentPage === 'SupportRequestDetailPage',
      disabled: false,
      linkProps: {
        name: 'MyRequestsPage',
      },
    },
    isProvider
      ? {
          text: <FormattedMessage id="UserNav.sales" />,
          selected: currentPage === 'SalesPage',
          disabled: false,
          linkProps: {
            name: 'SalesPage',
          },
        }
      : null,
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected:
        currentPage === 'AccountSettingsPage' || ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'AccountSettingsPage',
        params: { tab: 'contact-details' },
      },
    },
  ];

  const visibleTabs = tabs.filter(Boolean);
  return (
    <LinkTabNavHorizontal
      className={classes}
      tabRootClassName={css.tab}
      tabs={visibleTabs}
      skin="dark"
    />
  );
};

export default UserNav;
